<template>
  <div :class="['submit-btn-wrapper', {'offline_offsite_wraper': offline_offsite}, `${page_style}`]"  v-show="show" v-if="![4,5].includes(formItem.field_status)">
    <!-- <p v-if="offline_offsite" class="text-link">
      <span @click="showSite">{{offline_offsite.title}}</span>
    </p> -->
    <!-- :disabled="!is_finished" -->
    <input
      type="button"
      :value="btnTitle"
      :class="{'btn-photoinfo':1,'btn-photoinfo-active':is_finished}"
      :style="is_finished ? finishedBtnStyle : unfinishedBtnStyle"
      :disabled="!is_finished"
      @click="addInfo"
    />
    <!-- <offline-site ref="offlineSite" :config="offline_offsite||{}"></offline-site> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import OfflineSite from "../base/offline-site.vue";
import { ends } from "../../tools/constant";
import { getEnd } from "../../tools/utils";
import { post } from "../../tools/request";
import { SUPPORT_COUNTRY } from "../../tools/constant";
export default {
  props: ["formItem", "idx", "cm", "is_finished", "omegaItem", "page_style"],
  components: { OfflineSite },
  data() {
    return {
      ends
    }
  },
  computed: {
    ...mapState(["_ticket"]),
    offline_offsite() {
      return this.formItem["attach-link"];
    },
    show() {
      let end = getEnd();
      let d = this.formItem.display;
      if (!d) {
        return true;
      }
      return d.indexOf(end) > -1;
    },
    finished(){
      //端外均可下载
      if (this.formItem.link_type === "download") {
        return true
      }else{
        return this.is_finished
      }
    },
    submitBtn() {
      return this.formItem.button_color || { un_check: {}, is_check: {} };
    },
    finishedBtnStyle() { // 证件已全部提交
      let btnColor = this.submitBtn.is_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
        border: btnColor.border || 'none'
      }
    },
    unfinishedBtnStyle() { // 证件未全部提交
      let btnColor = this.submitBtn.un_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
        border: btnColor.border
      }
    },
    btnTitle() {
      return this.is_finished ? this.submitBtn.is_check.title : this.submitBtn.un_check.title;
    }
  },
  methods: {
    showSite() {
      if (this.offline_offsite.target == "blank") {
        location.href = this.offline_offsite.link;
        return;
      }
      this.$refs.offlineSite.getLineSite();
      this.$refs.offlineSite.show();
    },
    //提交物料
    addInfo() {
      if (!this.is_finished) {
        return;
      }
      try {
        Omega.trackEvent("ibt_gd_upload_submit_btn_ck", "", {
          ...this.omegaItem,
          // time: new Date().getTime()
        });
      } catch (error) {}
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let val = this.formItem.value;
      up.append(this.formItem.key, 1); // 提交按钮value写死
      post(process.env.ADD_AUDI_INFO, up)
        .then(() => {
          this.$router.replace({ name: "home" });
        })
        .catch(err => {
          // fail do nothing
        });
    }
  },
  mounted() {
    //更新按钮
    this.$emit("form-update", this.idx);
  },
  watch: {
    is_finished(newVal) {
      if (newVal) {
        this.$emit("form-update", this.idx);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.submit-btn-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.43rem 0.31rem;
  background: #fff;
  box-shadow: 0px -20px 20px 0px rgba(0,0,0,0.04);
  .btn-photoinfo {
    width: 6.84rem;
    height: 1.06rem;
    font-size: 0.36rem;
    color: #fff;
    font-weight: 700;
    text-align: center;
    background: #CCCCCC;
    border-radius: 0.12rem;
  }
  .btn-photoinfo-active {
    color: #fff;
    background: linear-gradient(45deg, #ff5b1d, #ff7f41);
  }
  &.h5_funnel_fleet,
  &.h5_funnel_fleet_pc {
    .btn-photoinfo {
      font-size: .4rem;
      color: #999999;
      background: #E9ECEE;
      border-radius: 0.2rem;
    }
    .btn-photoinfo-active {
      color: #333333;
      background-image: linear-gradient(-46deg, #FFAE1E 0%, #FFCA00 100%);
    }
  }
  &.h5_funnel_fleet_pc {
    position: relative;
    padding: 0 32px 100px 32px;
    margin-top: 64px;
    box-shadow: none;
    .btn-photoinfo {
      padding: 0;
      width: 100%;
      height: 52px;
      background: #E9ECEE;
      border-radius: 10px;
      font-size: 20px !important;
      color: #999999;
      font-weight: 700;
      border: none !important;
    }
  }
}
.has-img-fixed .btn-wraper {
  bottom: 3.9rem;
}
</style>
